<template>
  <div class='mainContainer' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='100px' :inline='true'>
        <el-form-item label='船名：'>
          <el-input v-model='searchForm.shipName' size='mini' placeholder='请输入船名' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='batchImport' @importSuccess='searchBtn'
                        @triggerLoading='importLoading = !importLoading' />
          <span style='cursor:pointer;font-size: 14px;color: rgba(51, 136, 255, 1);'
                @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'>
        <el-table-column label='船名' align='center'>
          <template slot-scope='scope'>
            <div :class='scope.row.status ? "inFlight" : "suspended"'>
              {{ scope.row.shipName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label='航向' prop='course' align='center' />
        <el-table-column label='船位' prop='shipPosition' align='center' />
        <el-table-column label='装载情况' prop='loadingCondition' align='center' />
        <el-table-column label='备注' prop='remarks' align='center' />
        <el-table-column label='船名' align='center'>
          <template slot-scope='scope'>
            <div :class='scope.row.status1 ? "inFlight" : "suspended"'>
              {{ scope.row.shipName1 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label='航向' prop='course1' align='center' />
        <el-table-column label='船位' prop='shipPosition1' align='center' />
        <el-table-column label='装载情况' prop='loadingCondition1' align='center' />
        <el-table-column label='备注' prop='remarks1' align='center' />
      </el-table>
    </div>

  </div>
</template>

<script>
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import BatchImport from '@/components/batchImport';
  import { indicatorSettingsList } from '@/service/supplierAssessment';
  import { shipRunningDynamicTableList } from '@/service/vehiclelog';

  export default {
    name: 'shipRunningDynamicTable',
    components: {
      BatchImport,
    },
    data() {
      return {
        importLoading: false,
        searchForm: {
          shipName: '',
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        batchImport: '/shipOperationInfo/batchImport',
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
    },
    methods: {
      download() {
        let token = getSessionStore('token');
        window.location.href = `${baseUrl}/platform/shipOperationInfo/exportTemplate?access_token=${token}`;
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await shipRunningDynamicTableList(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data;
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        const { shipName } = this.searchForm;
        // window.location.href = `${baseUrl}/platform/shipOperationInfo/exportExcel?access_token=${token}&shipName=${shipName}`;
        window.exportExcelGet('/platform/shipOperationInfo/exportExcel', `shipName=${shipName}`);
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }

  .inFlight {
    color: #00c800;
  }

  .suspended {
    color: #ff1c1c;
  }
</style>
